import { api } from "@";
import { searchValuesPayload } from "./helpers";

// Fetch donors with pagination and search filters
export const getDonors = (page, perSize, search) => {
  return api.post(
    `/api/adminuser/users/search`,
    searchValuesPayload({ ...search, page, perSize }),
  );
};

// Fetch donor details by ID
export const getDonor = (id) => api.get(`/api/adminuser/users/${id}/orders`);

// Toggle donor active status
export const donorToggleActive = (id, value) =>
  api.put(`/api/adminuser/${id}/change-status?isActive=${value}`);
